import type { HTMLAttributes, ReactNode } from 'react'

interface GlassPillProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode
}

/**
 * Liquid Glass pill — smaller-radius variant for chips, user badges, status
 * readouts. See DESIGN.md §14.
 */
export function GlassPill({ className = '', children, ...rest }: GlassPillProps) {
  return (
    <div className={`liquid-glass-pill rounded-full ${className}`} {...rest}>
      {children}
    </div>
  )
}
